export default __webpack_public_path__ + "static/ecm-logo-64c3bcf675410521b17a7052e66df300.svg";